module.exports = __webpack_public_path__ + "static/img/card-payment.9df6b29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pos/card-payment.png
// module id = H6En
// module chunks = 0